import type { Menu, MenuRecipe } from '../types/menu.types';

const translatedFields = [
  'name',
  'description',
  'nameEn',
  'nameEs',
  'nameFr',
  'descriptionEn',
  'descriptionEs',
  'descriptionFr',
] as const;

/** Keep the wire format independent from the normalized UI model. */
export function menuUpdateRequest(menu: Partial<Menu> & { menuId: number }) {
  const { active, ...rest } = menu;
  return {
    menuId: menu.menuId,
    ...Object.fromEntries(
      translatedFields
        .filter((key) => rest[key] !== undefined)
        .map((key) => [key, rest[key]]),
    ),
    ...(active === undefined ? {} : { isActive: active }),
    ...Object.fromEntries(
      ['isRecipesImgVisible', 'appliedTemplate', 'color']
        .filter((key) => key in rest)
        .map((key) => [key, rest[key as keyof typeof rest]]),
    ),
  };
}
export function recipeRequest(recipe: Partial<MenuRecipe> & { name: string }) {
  const raw = recipe as Record<string, unknown>;
  const fields = [
    ...translatedFields,
    'recipeCode',
    'price',
    'bestSeller',
    'positionIndex',
    'weight',
    'photoUrl',
    'allergens',
    'year',
    'wineType',
    'grapeVariety',
    'alcoholPercentage',
    'cupPrice',
    'cellar',
    'region',
    'customizable',
    'ingredientIds',
    'ingredientCategoryOrder',
    'minIngredientChoices',
    'maxIngredientChoices',
    'showIngredientsMenu',
    'showIngredientsTakeaway',
    'showIngredientsDelivery',
    'takeawayEnabled',
    'deliveryEnabled',
    'takeawayPrice',
    'deliveryPrice',
    'vegetarian',
    'vegan',
    'ingredients',
    'componentRecipeIds',
  ];
  return {
    ...Object.fromEntries(
      fields
        .filter((key) => raw[key] !== undefined)
        .map((key) => [key, raw[key]]),
    ),
    ...(raw.isVisible === undefined && raw.visible === undefined
      ? {}
      : { isVisible: raw.isVisible ?? raw.visible }),
    ...(raw.isWine === undefined && raw.wine === undefined
      ? {}
      : { isWine: raw.isWine ?? raw.wine }),
    ...(raw.isPricePerWeight === undefined && raw.pricePerWeight === undefined
      ? {}
      : { isPricePerWeight: raw.isPricePerWeight ?? raw.pricePerWeight }),
  };
}
